import { ICountry } from "../../types/countries"

export const computeCountries = (countriesApi: ICountry[]) => {
    return [...countriesApi].map((country) => {
        return {
            value: country.isoCode,
            label: country.name,
            id: country.id
        }
    })
}